/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 25/04/2021.
 */
import React from 'react'

export const BigSectionTitle = ({ label, className }) => {
  const cl = className ? className : 'mb-md-7 mb-5 '
  return <h4 className={cl}>{label}</h4>
}
